import { createSlice, Update } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';
import {
  DetailUserMasterResponse,
  GetDivisionListResponse,
  GetMenuAuthorityListResponse,
  GetUserGroupListResponse,
  GetDefaultPassword,
  SearchUserMasterRecord,
  SearchUserMasterResponse,
  GetDivisionListRequest,
  UpdateUserMasterRequest,
  DetailUserMasterRequest,
  DeleteUserMasterRequest,
} from 'api-types/src/types/user-mast';

type UserMastState = {
  userMastDataSearch: SearchUserMasterRecord[];
  menuAuthorityList: GetMenuAuthorityListResponse;
  total: number;
  loading: boolean;
  userGroupData: GetUserGroupListResponse;
  divisionList: GetDivisionListResponse;
  initialPassword: GetDefaultPassword;
  dataDetailUserMast: DetailUserMasterResponse | [];
  success: boolean;
  message: string;
  isBack: boolean;
};

const initialState: UserMastState = {
  userMastDataSearch: [],
  menuAuthorityList: [],
  total: 0,
  loading: false,
  userGroupData: [],
  divisionList: [],
  initialPassword: {
    PSWD: '',
    PSWD_END_YMD: '',
  },
  dataDetailUserMast: [],
  success: false,
  message: '',
  isBack: true,
};

export const userMastSlice = createSlice({
  name: 'userMast',
  initialState,
  reducers: {
    getMenuAuthority: () => {},
    getMenuAuthoritySuccess: (state, action: { payload: GetMenuAuthorityListResponse }) => {
      state.menuAuthorityList = action.payload;
    },
    getMenuAuthorityFailure: (state) => {},
    filterUserMast: (state, action) => {
      state.loading = true;
    },
    filterUserMastSuccess: (state, action: { payload: SearchUserMasterResponse }) => {
      state.userMastDataSearch = action.payload.records;
      state.total = action.payload.total;
      state.loading = false;
      state.message = '';
      if (action?.payload?.total === 0) {
        state.message = i18n.t('message.common.0001');
      }
    },
    filterUserMastFailure: (state) => {
      state.loading = false;
    },
    clearDivisionList: (state) => {
      state.divisionList = [];
    },
    clearData: (state, action) => {
      state.userMastDataSearch = action.payload?.userMastDataSearch;
      state.divisionList = action.payload?.divisionList;
      state.dataDetailUserMast = action.payload?.dataDetailUserMast;
      state.total = 0;
      state.initialPassword = action.payload?.initialPassword;
      state.message = action.payload?.message;
      state.isBack = action.payload?.isBack;
    },
    getUserGroup: (state) => {},
    getUserGroupSuccess: (state, action: { payload: GetUserGroupListResponse }) => {
      state.userGroupData = action.payload;
    },
    getUserGroupFailure: (state) => {},
    getDivisionList: (state, action: { payload: GetDivisionListRequest }) => {},
    getDivisionListSuccess: (state, action: { payload: GetDivisionListResponse }) => {
      state.divisionList = action.payload;
    },
    getDivisionListFailure: (state) => {},
    getInitializationPw: (state) => {},
    getInitializationPwSuccess: (state, action: { payload: GetDefaultPassword }) => {
      state.initialPassword = {
        PSWD: action.payload.PSWD,
        PSWD_END_YMD: action.payload.PSWD_END_YMD,
      };
    },
    getInitializationPwFailure: (state) => {},
    addUserMast: (state, action: { payload: { body: UpdateUserMasterRequest; onSuccess: () => void } }) => {},
    addUserMastSuccess: (state, action) => {
      state.success = true;
    },
    addUserMastFailure: (state) => {
      state.success = false;
    },
    getDetailUserMast: (state, action: { payload: { USER_ID: string; onFail?: () => void } }) => {
      state.loading = true;
    },
    getDetailUserMastSuccess: (state, action: { payload: DetailUserMasterResponse }) => {
      state.dataDetailUserMast = action.payload;
      state.loading = false;
    },
    getDetailUserMastFailure: (state) => {
      state.loading = false;
    },
    deleteUserMast: (state, action: { payload: { body: DeleteUserMasterRequest; onSuccess: () => void } }) => {},
    deleteUserMastSuccess: (state, action) => {
      state.success = true;
    },
    deleteUserMastFailure: (state) => {
      state.success = false;
    },
    updateUserMast: (state, action: { payload: { body: UpdateUserMasterRequest; onSuccess: () => void } }) => {},
    updateUserMastSuccess: (state, action) => {
      state.success = true;
    },
    updateUserMastFailure: (state) => {
      state.success = false;
    },
    setIsSuccess: (state, action) => {
      state.success = action.payload.success;
    },
  },
});

export const {
  getMenuAuthority,
  getMenuAuthoritySuccess,
  getMenuAuthorityFailure,
  filterUserMast,
  filterUserMastSuccess,
  filterUserMastFailure,
  clearDivisionList,
  clearData,
  getUserGroup,
  getUserGroupSuccess,
  getUserGroupFailure,
  getDivisionList,
  getDivisionListSuccess,
  getDivisionListFailure,
  getInitializationPw,
  getInitializationPwSuccess,
  getInitializationPwFailure,
  addUserMast,
  addUserMastSuccess,
  addUserMastFailure,
  getDetailUserMast,
  getDetailUserMastSuccess,
  getDetailUserMastFailure,
  deleteUserMast,
  deleteUserMastSuccess,
  deleteUserMastFailure,
  updateUserMast,
  updateUserMastSuccess,
  updateUserMastFailure,
  setIsSuccess,
} = userMastSlice.actions;

export default userMastSlice.reducer;
